<template>
    <div class="social_media">
        <a v-if="social.email != ''" :href="`mailto:${social.email}`"><i class="fa-solid fa-envelope"></i></a>
        <a v-if="social.behance != ''" :href="social.behance" target="_blank"><i class="fa-brands fa-behance"></i></a>
        <a v-if="social.instagram != ''" :href="social.instagram" target="_blank"><i class="fa-brands fa-instagram"></i></a>
        <a v-if="social.linkedin != ''" :href="social.linkedin" target="_blank"><i class="fa-brands fa-linkedin-in"></i></a>
        <a v-if="social.whatsapp != ''" :href="`https://wa.me/${social.whatsapp}`" target="_blank"><i class="fa-brands fa-whatsapp"></i></a>
        <a v-if="social.phone != ''" :href="`tel:${social.phone}`"><i class="fa-solid fa-phone"></i></a>
        <a v-if="social.facebook != ''" :href="social.facebook" target="_blank"><i class="fa-brands fa-facebook-f"></i></a>
        <a v-if="social.location != ''" :href="social.location" target="_blank"><i class="fa-solid fa-location-dot"></i></a>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: "social-media",
    data() {
        return {
            social: {}
        }
    },
    methods: {
        fetchSocial() {
            axios
              .get("/fetch_settings")
              .then(({ data }) => {
                this.social = data.data;
                // console.log(this.meals , "meals");
            })
            .catch((error) => {
                return error
            });
        }
    },
    created() {
        this.fetchSocial()
    }
}
</script>

<style>

</style>